import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getData, patchData, getRemoteUrl } from './request'
import { addCases } from './utils'
import { getLoginToken } from './store'


function setErrorState(state, { error }) {
    state.requestError = error
}

function setUserGeneralInfo(state, { payload }) {
    state.info = payload
    state.infoIsLoading = false
    state.needsServerUpdate = false
}

function setUserGeneralInfoLoading(state) {
    state.infoIsLoading = true
    state.needsServerUpdate = false
}

function reqUserGeneralInfo() {
    const loginToken = getLoginToken()
    let params = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${loginToken}`
        }
    }

    return getData(getRemoteUrl("users/me"), params)
}

export function sendInfoToServer(info) {
    const loginToken = getLoginToken()
    const payload = {
        first_name: info.first_name,
        second_name: info.second_name,
        email: info.email,
        birthday: info.birthday
    }

    return patchData(getRemoteUrl("users/me"), payload, loginToken)
};

export const asyncReqUserGeneralInfo = createAsyncThunk('asyncReqUserGeneralInfo', reqUserGeneralInfo)

export const userinfoSlice = createSlice({
    name: 'userinfo',
    initialState: {
        info: {},
        infoIsLoading:false,
        needsServerUpdate:false
    },

    reducers: {
        setFirstName(state, {payload}) {
            state.info.first_name = payload
            state.needsServerUpdate = true
        },
        setSecondName(state, {payload}) {
            state.info.second_name = payload
            state.needsServerUpdate = true
        },
        setEmail(state, {payload}) {
            state.info.email = payload
            state.needsServerUpdate = true
        },
        setBirthdayDate(state, {payload}) {
            state.info.birthday = payload
            state.needsServerUpdate = true
        },

        submitInfoToServer(state) {
            state.needsServerUpdate = false
        }
    },

    extraReducers: builder => {
        addCases(builder, asyncReqUserGeneralInfo, setUserGeneralInfo, setUserGeneralInfoLoading, setErrorState)
    }
})

export const { setFirstName, setSecondName, setEmail, submitInfoToServer, setBirthdayDate } = userinfoSlice.actions
